import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { AccountData } from "../generated";
import { AccountCircle } from "./AccountCircle";
import { Link } from "../common/components/link";
import { links } from "../routes";
import { canRequireUser } from "../login/loginHelpers";
import LoginActions from "../login/LoginActions";
import { LicenseAlertMenu } from "./LicenseAlert";
import { DropDownContainer } from "../common/components/dropDownMenu";
import DatesHelper from "../common/datesHelper";
const userLogo = require("../assets/images/users/plumber.jpg");

interface Props extends RouteComponentProps {
    user: AccountData | null;
}

class AccountWidget extends React.Component<Props> {

    private onSignOut = async () => {
        await LoginActions.signOut();
    }

    render() {
        const { user } = this.props;
        if (user == null)
            return (<li className="nav-item">
                <Link
                    to={links.login}
                    className="nav-link text-muted waves-effect waves-dark"
                    style={{ color: "white", fontSize: "1rem" }} >
                    <i className="fas fa-sign-in-alt me-1" /> Accedi
                </Link>
            </li>);
        const username = user.nomeOperatore!.trim();
        return (
            <div className="d-flex align-items-center">
                <LicenseAlertMenu expiration={user.expiration} />
                <DropDownContainer>
                    {
                        toggle => <li className="nav-item dropleft">
                            <a
                                aria-expanded="false"
                                className="nav-link text-muted waves-effect waves-dark dropdowncontainer-toggle"
                                onClick={toggle}
                                data-bs-toggle="dropdown"
                                title={`Utente ${username}`}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <AccountCircle user={user} />
                                    <i className="fas fa-chevron-down ms-2" style={{ fontSize: "0.8rem" }} />
                                </div>
                            </a>
                            <div className="dropdown-menu scale-up dropdown-menu-end">
                                <ul className="dropdown-user">
                                    <li>
                                        <div className="dw-user-box d-flex">
                                            <div className="u-img">
                                                <img src={userLogo} alt="user" />
                                            </div>
                                            {user != null && <div className="u-text">
                                                <h4>{`${user.nomeOperatore}`}</h4>
                                                <p className="text-muted">Scadenza: {DatesHelper.getReadableDateString(user.expiration)}</p>
                                                <p className="text-muted">{user.username}</p>
                                                <Link to={links.companyEdit} className="btn btn-rounded btn-danger mt-3">
                                                    La mia azienda
                                                </Link>
                                            </div>}
                                        </div>
                                    </li>
                                    <li role="separator" className="divider" />
                                    <li>
                                        <a href="mailto:info@caldaiemanager.it">
                                            <i className="fas fa-question-circle" /> Richiedi assistenza
                                        </a>
                                    </li>
                                    {user != null &&
                                        <>
                                            < li role="separator" className="divider" />
                                            <li>
                                                <Link to={links.login} onClick={this.onSignOut}>
                                                    <i className="fa fa-power-off" /> Logout
                                                </Link>
                                            </li>
                                        </>}
                                </ul>
                            </div>
                        </li>
                    }
                </DropDownContainer>

            </div>)
    }
}

export default canRequireUser(withRouter(AccountWidget));